import React, { PureComponent } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import moment from "moment";

import { getListingImage } from "../../../constants/util";

function formatAsCurrency(value) {
  return isNaN(value)
    ? null
    : value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
}

class DashboardBookingLarge extends PureComponent {
  constructor(props) {
    super(props);
  }

  getBookingStatus(bookingPaymentStatus, bookingRequestStatus) {
    if (bookingRequestStatus !== "Accepted") {
      return bookingRequestStatus;
    } else if (bookingPaymentStatus === "Pending") {
      return `Payment ${bookingPaymentStatus}`;
    } else {
      return bookingPaymentStatus;
    }
  }

  render() {
    let { booking, isOwner } = this.props;
    let startDate = moment(booking.startDate);
    let endDate = moment(booking.endDate);
    let numDays = Math.ceil(endDate.diff(startDate, "d", true));
    let nightText = numDays > 1 ? "nights" : "night";
    return (
      <Link to={`/dashboard/bookings/${booking._id}`}>
        <div className="dashboard-booking-large">
          <div className="row">
            <div className="col">
              <h6>
                {startDate.format("M/D/YY")} - {endDate.format("M/D/YY")} (
                {numDays} {nightText})
              </h6>
            </div>
          </div>
          <div className="row d-flex">
            {booking.listingId.photos.length > 0 && (
              <div className="col-md-4 pr-0 image-container">
                <div
                  style={{
                    backgroundImage: `url(${getListingImage(
                      booking.listingId
                    )})`,
                  }}
                />
              </div>
            )}
            <div className="col d-block">
              <div className="font-weight-bold">
                {booking.listingId.listingName}
              </div>
              <div className="">
                {booking.listingId.address.city},{" "}
                {booking.listingId.address.state}
              </div>
              <div className="">
                {booking.userId.firstName}{" "}
                {booking.userId.lastName.substr(0, 1)}. | 3 guests
              </div>
              <div>
                Status:{" "}
                {this.getBookingStatus(
                  booking.bookingPaymentStatus,
                  booking.bookingRequestStatus
                )}
              </div>
              <div>
                Total: $
                {formatAsCurrency(isOwner ? booking.ownerTotal : booking.total)}
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

export default withRouter(DashboardBookingLarge);
